// src/pages/Favorites/Favorites.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useFavorites } from '../../hooks/useFavorites.js';
import { useToast } from '../../hooks/useToast.js';
import { Breadcrumbs } from '../../components/common/Breadcrumbs/Breadcrumbs';
import { Button } from '../../components/ui/Button/Button.jsx';
import { Loader } from '../../components/ui/Loader/Loader.jsx';
import { ProductCard } from '../../components/common/ProductCard/ProductCard.jsx';

export const Favorites = () => {
  const { items, getFavorites, removeFromFavorites, isLoading } = useFavorites();
  const { success, error } = useToast();

  useEffect(() => {
    getFavorites();
  }, []);

  const handleRemove = async (productId) => {
    try {
      await removeFromFavorites(productId);
      success('Удалено из избранного');
    } catch (err) {
      error('Не удалось удалить из избранного');
    }
  };

  const breadcrumbs = [{ label: 'Избранное', path: '/favorites' }];

  return (
    <div style={{ backgroundColor: 'rgb(var(--c-bg))', minHeight: '100vh', paddingBottom: '40px' }}>
      <div className="container" style={{ paddingTop: '24px' }}>
        <Breadcrumbs items={breadcrumbs} />

        <h1 style={{
          fontSize: '32px',
          fontWeight: 700,
          color: 'rgb(var(--c-text))',
          marginTop: '24px',
          marginBottom: '32px',
        }}>
          Избранное
        </h1>

        {isLoading ? (
          <Loader text="Загрузка избранного..." />
        ) : items.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '60px 0',
            backgroundColor: 'rgb(var(--c-surface))',
            borderRadius: '20px',
            border: '1px solid rgb(var(--c-border))',
          }}>
            <p style={{ fontSize: '18px', color: 'rgb(var(--c-text-secondary))' }}>Избранное пусто</p>
            <Link to="/catalog">
              <Button style={{ marginTop: '16px' }}>Перейти в каталог</Button>
            </Link>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '24px',
          }}>
            {items.map((product) => (
              <div key={product.id} style={{ position: 'relative' }}>
                <ProductCard product={product} variant="grid" />
                <button
                  onClick={() => handleRemove(product.id)}
                  style={{
                    position: 'absolute',
                    top: '12px',
                    right: '12px',
                    background: 'rgba(255,255,255,0.9)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  }}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};